<template>
<div class="columns is-multiline">
    <div class="column is-12">
        <div class="field">
            <input v-model="name" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Account name" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="!hasError('name')" class="help">An intuitive name to recognize the account later.</span>
            <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
        </div>
    </div>
    <div class="column is-12">
        <div class="field">
            <textarea v-model="key" class="textarea custom-input-size" :class="{ 'is-danger': hasError('gcp_key') }" style="padding: 10px 15px !important;" :disabled="creatingAccount" placeholder="JSON of Google Service Account"></textarea>
            <!-- <span v-if="!hasError('included_paths')" class="help">Absolute paths of directories/files that should be included in the backup. One path per line.</span> -->
            <!-- <span v-if="hasError('included_paths')" class="help is-danger">{{ getError('included_paths') }}</span> -->
            <!-- <input v-model="key" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('aws_key') }" class="input custom-input-size is-medium" placeholder="Key Id" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="hasError('aws_key')" class="help is-danger">{{ getError('aws_key') }}</span>
            <span v-if="!hasError('aws_key')" class="help">Your AWS Access Key ID.</span> -->
        </div>
    </div>
    <div class="column is-12" style="margin-bottom: 10px;">
        <div class="field">
            <div class="control has-icons-left">
                <div class="select is-fullwidth">
                    <select v-model="regionKey" :disabled="creatingAccount" name="aws-region">
                        <option v-for="region in regions" :value="region.key" v-bind:key="region.key">{{ region.name }}</option>
                    </select>
                </div>
                <div class="icon is-left is-custom-icon-left">
                    <font-awesome-icon icon="globe-americas"/>
                </div>
            </div>
        </div>
        <span class="help" style="display: inline-block; margin-top: 6px;">The region where the VM instances/disks are located.</span>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            name: '',
            key: '',
            regionKey: 'europe-west3-a',
            allowedInputs: ['name', 'gcp_key', 'gcp_region'],
            error: '',
            creatingAccount: false,
            regions: [
                {
                    key: 'asia-east1-a',
                    name: 'Changhua County, Taiwan - Zone A (asia-east1-a)'
                },
                {
                    key: 'asia-east1-b',
                    name: 'Changhua County, Taiwan - Zone B (asia-east1-b)'
                },
                {
                    key: 'asia-east1-c',
                    name: 'Changhua County, Taiwan - Zone C (asia-east1-c)'
                },
                {
                    key: 'asia-east2-a',
                    name: 'Hong Kong - Zone A (asia-east2-a)',

                },
                {
                    key: 'asia-east2-b',
                    name: 'Hong Kong - Zone B (asia-east2-b)',

                },
                {
                    key: 'asia-east2-c',
                    name: 'Hong Kong - Zone C (asia-east2-c)',

                },
                {
                    key: 'asia-northeast1-a',
                    name: 'Tokyo, Japan - Zone A (asia-northeast1-a)',
                },
                {
                    key: 'asia-northeast1-b',
                    name: 'Tokyo, Japan - Zone B (asia-northeast1-b)',
                },
                {
                    key: 'asia-northeast1-c',
                    name: 'Tokyo, Japan - Zone C (asia-northeast1-c)',
                },
                {
                    key: 'asia-northeast2-a',
                    name: 'Osaka, Japan - Zone A (asia-northeast2-a)',
                },
                {
                    key: 'asia-northeast2-b',
                    name: 'Osaka, Japan - Zone B (asia-northeast2-b)',
                },
                {
                    key: 'asia-northeast2-c',
                    name: 'Osaka, Japan - Zone C (asia-northeast2-c)',
                },
                {
                    key: 'asia-northeast3-a',
                    name: 'Seoul, South Korea - Zone A (asia-northeast3-a)',
                },
                {
                    key: 'asia-northeast3-b',
                    name: 'Seoul, South Korea - Zone B (asia-northeast3-b)',
                },
                {
                    key: 'asia-northeast3-c',
                    name: 'Seoul, South Korea - Zone C (asia-northeast3-c)',
                },
                {
                    key: 'asia-south1-a',
                    name: 'Mumbai, India - Zone A (asia-south1-a)',
                },
                {
                    key: 'asia-south1-b',
                    name: 'Mumbai, India - Zone B (asia-south1-b)',
                },
                {
                    key: 'asia-south1-c',
                    name: 'Mumbai, India - Zone C (asia-south1-c)',
                },
                {
                    key: 'asia-southeast1-a',
                    name: 'Jurong West, Singapore - Zone A (asia-southeast1-a)',
                },
                {
                    key: 'asia-southeast1-b',
                    name: 'Jurong West, Singapore - Zone B (asia-southeast1-b)',
                },
                {
                    key: 'asia-southeast1-c',
                    name: 'Jurong West, Singapore - Zone C (asia-southeast1-c)',
                },
                {
                    key: 'asia-southeast2-a',
                    name: 'Jakarta, Indonesia - Zone A (asia-southeast2-a)',
                },
                {
                    key: 'asia-southeast2-b',
                    name: 'Jakarta, Indonesia - Zone B (asia-southeast2-b)',
                },
                {
                    key: 'asia-southeast2-c',
                    name: 'Jakarta, Indonesia - Zone C (asia-southeast2-c)',
                },
                {
                    key: 'australia-southeast1-a',
                    name: 'Sydney, Australia - Zone A (australia-southeast1-a)',
                },
                {
                    key: 'australia-southeast1-b',
                    name: 'Sydney, Australia - Zone B (australia-southeast1-b)',
                },
                {
                    key: 'australia-southeast1-c',
                    name: 'Sydney, Australia - Zone C (australia-southeast1-c)',
                },
                {
                    key: 'europe-north1-a',
                    name: 'Hamina, Finland - Zone A (europe-north1-a)',
                },
                {
                    key: 'europe-north1-b',
                    name: 'Hamina, Finland - Zone B (europe-north1-b)',
                },
                {
                    key: 'europe-north1-c',
                    name: 'Hamina, Finland - Zone C (europe-north1-c)',
                },
                {
                    key: 'europe-west1-b',
                    name: 'St. Ghislain, Belgium - Zone B (europe-west1-b)',
                },
                {
                    key: 'europe-west1-c',
                    name: 'St. Ghislain, Belgium - Zone C (europe-west1-c)',
                },
                {
                    key: 'europe-west1-d',
                    name: 'St. Ghislain, Belgium - Zone D (europe-west1-d)',
                },
                {
                    key: 'europe-west2-a',
                    name: 'London, England - Zone A (europe-west2-a)',
                },
                {
                    key: 'europe-west2-b',
                    name: 'London, England - Zone B (europe-west2-b)',
                },
                {
                    key: 'europe-west2-c',
                    name: 'London, England - Zone C (europe-west2-c)',
                },
                {
                    key: 'europe-west3-a',
                    name: 'Frankfurt, Germany - Zone A (europe-west3-a)',
                },
                {
                    key: 'europe-west3-b',
                    name: 'Frankfurt, Germany - Zone B (europe-west3-b)',
                },
                {
                    key: 'europe-west3-c',
                    name: 'Frankfurt, Germany - Zone C (europe-west3-c)',
                },
                {
                    key: 'europe-west4-a',
                    name: 'Eemshaven, Netherlands - Zone A (europe-west4-a)',
                },
                {
                    key: 'europe-west4-b',
                    name: 'Eemshaven, Netherlands - Zone B (europe-west4-b)',
                },
                {
                    key: 'europe-west4-c',
                    name: 'Eemshaven, Netherlands - Zone C (europe-west4-c)',
                },
                {
                    key: 'europe-west6-a',
                    name: 'Zurich, Switzerland - Zone A (europe-west6-a)',
                },
                {
                    key: 'europe-west6-b',
                    name: 'Zurich, Switzerland - Zone B (europe-west6-b)',
                },
                {
                    key: 'europe-west6-c',
                    name: 'Zurich, Switzerland - Zone C (europe-west6-c)',
                },
                {
                    key: 'northamerica-northeast1-a',
                    name: 'Montréal, Québec - Zone A (northamerica-northeast1-a)',
                },
                {
                    key: 'northamerica-northeast1-b',
                    name: 'Montréal, Québec - Zone B (northamerica-northeast1-b)',
                },
                {
                    key: 'northamerica-northeast1-c',
                    name: 'Montréal, Québec - Zone C (northamerica-northeast1-c)',
                },
                {
                    key: 'southamerica-east1-a',
                    name: 'Osasco, São Paulo, Brazil - Zone A (southamerica-east1-a)',
                },
                {
                    key: 'southamerica-east1-b',
                    name: 'Osasco, São Paulo, Brazil - Zone B (southamerica-east1-b)',
                },
                {
                    key: 'southamerica-east1-c',
                    name: 'Osasco, São Paulo, Brazil - Zone C (southamerica-east1-c)',
                },
                {
                    key: 'us-central1-a',
                    name: 'Council Bluffs, Iowa - Zone A (us-central1-a)',
                },
                {
                    key: 'us-central1-b',
                    name: 'Council Bluffs, Iowa - Zone B (us-central1-b)',
                },
                {
                    key: 'us-central1-c',
                    name: 'Council Bluffs, Iowa - Zone C (us-central1-c)',
                },
                {
                    key: 'us-central1-f',
                    name: 'Council Bluffs, Iowa - Zone F (us-central1-f)',
                },
                {
                    key: 'us-east1-b',
                    name: 'Moncks Corner, South Carolina - Zone B (us-east1-b)',
                },
                {
                    key: 'us-east1-c',
                    name: 'Moncks Corner, South Carolina - Zone C (us-east1-c)',
                },
                {
                    key: 'us-east1-d',
                    name: 'Moncks Corner, South Carolina - Zone D (us-east1-d)',
                },
                {
                    key: 'us-east4-a',
                    name: 'Ashburn, Virginia - Zone A (us-east4-a)',
                },
                {
                    key: 'us-east4-b',
                    name: 'Ashburn, Virginia - Zone B (us-east4-b)',
                },
                {
                    key: 'us-east4-c',
                    name: 'Ashburn, Virginia - Zone C (us-east4-c)',
                },
                {
                    key: 'us-west1-a',
                    name: 'The Dalles, Oregon - Zone A (us-west1-a)',
                },
                {
                    key: 'us-west1-b',
                    name: 'The Dalles, Oregon - Zone B (us-west1-b)',
                },
                {
                    key: 'us-west1-c',
                    name: 'The Dalles, Oregon - Zone C (us-west1-c)',
                },
                {
                    key: 'us-west2-a',
                    name: 'Los Angeles, California - Zone A (us-west2-a)',
                },
                {
                    key: 'us-west2-b',
                    name: 'Los Angeles, California - Zone B (us-west2-b)',
                },
                {
                    key: 'us-west2-c',
                    name: 'Los Angeles, California - Zone C (us-west2-c)',
                },
                {
                    key: 'us-west3-a',
                    name: 'Salt Lake City, Utah - Zone A (us-west3-a)',
                },
                {
                    key: 'us-west3-b',
                    name: 'Salt Lake City, Utah - Zone B (us-west3-b)',
                },
                {
                    key: 'us-west3-c',
                    name: 'Salt Lake City, Utah - Zone C (us-west3-c)',
                },
                {
                    key: 'us-west4-a',
                    name: 'Las Vegas, Nevada - Zone A (us-west4-a)',
                },
                {
                    key: 'us-west4-b',
                    name: 'Las Vegas, Nevada - Zone B (us-west4-b)',
                },
                {
                    key: 'us-west4-c',
                    name: 'Las Vegas, Nevada - Zone C (us-west4-c)',
                },
                
            ],
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        createAccount() {
            if (this.creatingAccount) {
                return;
            }

            this.creatingAccount = true;
            this.resetErrors();

            Api().post('accounts', this.newAccountData)
                .then(response => {
                    Event.$emit('refreshAccounts', () => {
                        Event.$emit('closeAddAccount');
                        swal('Success!', 'The GCP account was connected.', 'success');
                    });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.creatingAccount = false;
                });
        },

        listenEvents() {
            let vm = this;

            Event.$on('createProviderAccount', (providerSlug) => {
                if (providerSlug == 'gcp') {
                    vm.createAccount();
                }
            });

            Event.$on('addAccountClosed', () => {
                this.resetErrors();
                this.name = '';
                this.key = '';
                this.secret = '';
                this.regionKey = 'europe-west3-a';
                this.error = '';
            });
        },
    },

    computed: {
        newAccountData() {
            return {
                provider_slug: 'gcp',
                name: this.name,
                gcp_key: this.key,
                gcp_region: this.regionKey,
            }
        },
    },

    watch: {
        creatingAccount(creatingAccount) {
            Event.$emit('creatingAccountLoaderUpdated', creatingAccount);
        },
    },
}
</script>
